import React from "react";
import { AnimatePresence } from "framer-motion";

import ResedentialFacilities from "./Residential_Facilities/Residential_Facilities";

import "./Css/Homepage.css";

function Resident() {
  return (
    <AnimatePresence>
      <ResedentialFacilities />
    </AnimatePresence>
  );
}

export default Resident;
